import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getCampaignsWithOOCFrames = createSelector(
  (state: Store) => state.directSalesOOC.campaignsWithOOCFrames,
  (campaignsWithOOCFrames) => campaignsWithOOCFrames,
);

export const getCampaignIdsWithOOCFrames = createSelector(
  (state: Store) => state.directSalesOOC.campaignsWithOOCFrames,
  (campaignsWithOOCFrames) =>
    campaignsWithOOCFrames.reduce<Record<string, true>>((acc, campaign) => {
      acc[campaign.campaignId] = true;
      return acc;
    }, {}),
);

export const getOOCFramesCount = createSelector(
  (state: Store) => state.directSalesOOC.campaignsWithOOCFrames,
  (campaignsWithOOCFrames) => campaignsWithOOCFrames.reduce((acc, curr) => acc + curr.frameDetails.length, 0),
);
